document.addEventListener('DOMContentLoaded', async () => {
	const masonryContainers = document.querySelectorAll('.is-masonry');

	if (masonryContainers.length > 0) {
		const Masonry = await import('masonry-layout');
		masonryContainers.forEach((masonryContainer) => {
			const gridItems = masonryContainer.querySelectorAll('.grid-item');
			if (gridItems.length > 0) {
				const gutter = parseInt(masonryContainer.getAttribute('data-masonry-gap'), 10) || 0;

				gridItems.forEach((gridItem) => {
					gridItem.style.marginBottom = `${gutter}px`;
				});

				new Masonry.default(masonryContainer, {
					itemSelector: '.grid-item',
					gutter: gutter
				});
			}
		});
	}
});
